import { useEffect, useState } from "react";
import { baseUrl } from "../../connections";

export const useAllCities = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${baseUrl}/city/list/all?pagenum=0&limit=100&search=`)
      .then(async (response) => {
        const res = await response.text();
        if (response.status !== 200) {
          throw res;
        }
        return JSON.parse(res);
      })
      .then((result) => {
        setData(result?.data ?? []);
        setError(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, []);

  return {
    cityList: data,
    isLoading,
    error,
  };
};
